<script setup lang="ts">
const props = defineProps<{
    maxWidth?: string
}>()

const maxWidthClass = computed(() => {
    const spacing = 'px-9 mx-auto'

    if (props.maxWidth) {
        if (props.maxWidth === 'max-w-full') {
            return props.maxWidth
        }
        return `${props.maxWidth} ${spacing}`
    }
    return `max-w-7xl ${spacing}`
})
</script>

<template>
    <div :class="maxWidthClass">
        <slot />
    </div>
</template>
